import styled from 'styled-components';
import { space, width } from 'styled-system';
import { Input as AntInput } from 'antd';

const Input = styled(AntInput)`
  ${space};
  ${width};
`;

export const HiddenInput = styled.input`
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  position: absolute;
  width: 1px;
`;

export default Input;
